import React, { Component } from 'react';
import UrlForm from '../components/UrlForm';
import { connect } from 'react-redux';
import * as actions from '../actions';

class UrlFormContainer extends Component {
  submit = values => {
    console.log('values', values);
    this.props.getRemoteManifest(values.url);
  };

  render() {
    return <UrlForm onSubmit={this.submit} />;
  }
}

const mapDispatchToProps = dispatch => ({
  getRemoteManifest: url => dispatch(actions.getRemoteManifest(url))
});

export default connect(null, mapDispatchToProps)(UrlFormContainer);



// WEBPACK FOOTER //
// ./src/containers/UrlFormContainer.js